

import initMenu from './header-menu.js';
import headerActions from './header-actions.js';

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(async ($) => {

	// --- Begin: sticky-header ---

	const $header = $('#header[data-sticky-header]');
	const $headerTop = $('#header_top');
	const bodyEl = document.body;

	if ($header.length > 0) {

		// Add sticky modifiers depending on scroll and header offsetHeight
		const manageStickyHeader = () => {
			const $header = $('#header[data-sticky-header]');
			const headerEl = $header[0];
			if (mpro.getDocScrollPos()[1] > 1) {
				const $headerWrapper = $('#header_wrapper');
				const $headerMenuWrapper = $('#header_menu_wrapper');
				const $productContentTabs = $('#product_content_tabs');

				bodyEl.style.paddingTop = `${headerEl.offsetHeight}px`;
				!headerEl.classList.contains('header--sticky') && headerEl.classList.add('header--sticky');
				!bodyEl.classList.contains('header-sticky') && bodyEl.classList.add('header-sticky');

				if ($productContentTabs.length > 0) {
					// Align content tabs for themes with horizontal menu
					const top = ($headerWrapper.is(':visible') ? $headerWrapper.outerHeight() : 0) +
						($headerMenuWrapper.length > 0 && $headerMenuWrapper.is(':visible') ? $headerMenuWrapper.outerHeight() : 0);
					$productContentTabs.css({ 'top': top });
				}
			}
			else {
				bodyEl.style.paddingTop = '0';
				headerEl.classList.contains('header--sticky') && headerEl.classList.remove('header--sticky');
				bodyEl.classList.contains('header-sticky') && bodyEl.classList.remove('header-sticky');
			}
		};

		manageStickyHeader();

		$header.on('destroy', '#header[data-sticky-header]', () => {
			document.removeEventListener('scroll', manageStickyHeader);
		});

		// run handler on scroll
		document.addEventListener('scroll', manageStickyHeader, { passive: true });
	}

	// Align content tabs for themes with vertical menu
	if ($headerTop.length > 0) {

		// Add sticky modifiers depending on scroll and header offsetHeight
		const manageHeaderTop = () => {
			const $productContentTabs = $('#product_content_tabs');
			if ($productContentTabs.length > 0) {
				const top = ($headerTop.is(':visible') ? $headerTop.outerHeight() : 0);
				$productContentTabs.css({ 'top': top });
			}
		};

		manageHeaderTop();
	}

	// --- End: sticky-header ---

	// Populate counters
	$('[data-toggle-cart]').attr('data-count', mpro.config.cart.count_items);
	$('[data-toggle-wishlist]').attr('data-count', mpro.config.wishlist.count_items);
	$('[data-toggle-comparer]').find('[data-count]').attr('data-count', mpro.config.comparer.count_items);
});

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async ($container) => {

	/** @type {Promise<any>[]} */
	const initProm = [];

	// Get the tippy containers
	const $menuElements = $container.find('[data-header-menu]');
	const $actionElements = $container.find('[data-header-actions],[data-footer-actions]');

	// Add menu init
	if ($menuElements.length > 0) {
		initProm.push(initMenu($container));
	}

	// Add actions init
	if ($actionElements.length > 0) {

		// Reset previously initialized instances (for ajax navigation)
		headerActions.reset();

		initProm.push(
			headerActions.user.init($container),
			headerActions.search.init($container),
			headerActions.cart.init($container),
			headerActions.comparer.init($container),
			headerActions.selector.init($container),
		);
	}

	if (initProm.length > 0) {

		// Wait for all plugin instances to load
		await Promise.all(initProm);

		// Do something after all promises are ready
		// ....
	}
});
